import { render, staticRenderFns } from "./PricelistTemplateDetail.vue?vue&type=template&id=93b1b3a6&"
import script from "./PricelistTemplateDetail.vue?vue&type=script&lang=ts&"
export * from "./PricelistTemplateDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports